<div class="root">
  <div *ngIf="title" class="title-container">
    <span class="title">{{ title }}</span>
  </div>

  <ng-container *ngFor="let item of items; let i = index">
    <div
      class="item"
      [class.active-item]="item === value"
      [class.bottom-border]="!isLastItem(items, i)"
      (click)="handleSelection(item)"
    >
      <span class="item-label">{{ item }}</span>

      <div>
        <app-lucide-icon [iconName]="'chevron-right'"></app-lucide-icon>
      </div>
    </div>
  </ng-container>
</div>
